import React, {createContext} from 'react';
import {Constants} from './view-constants';

export const articleOverviewStaticContext = createContext();

export function ArticleOverviewStaticProvider({
    configurationContent,
    searchParams,
    urlPath,
    categoryPath,
    prettyUrl,
    shopId,
    filterRootShopId,
    rootCategoryPath,
    children,
}) {
    const value = {
        texts: configurationContent.texts,
        imagePath: configurationContent.imagePath,
        browser: configurationContent.browser,
        abTextTooLong: configurationContent.abTextTooLong,
        showCurrencyAsPrefix: configurationContent.showCurrencyAsPrefix,
        facadeFailure: configurationContent.facadeFailure,
        lazyloadingPixelDistanceForReco: configurationContent.lazyloadingPixelDistanceForReco,
        chunkSize: configurationContent.chunkSize,
        numberOfChunks: configurationContent.numberOfChunks,
        wishlistEnabled: configurationContent.wishlistEnabled,
        filterAjaxUrl: configurationContent.filterAjaxUrl,
        contentAjaxUrl: configurationContent.contentAjaxUrl,
        articleAjaxUrl: configurationContent.articleAjaxUrl,

        filterTestGroup: configurationContent.filterTestGroup,

        currentSearchParams: searchParams,
        currentUrlPath: urlPath,
        currentCategoryPath: categoryPath,
        prettyUrl: prettyUrl,
        shopId: shopId,
        filterRootShopId: filterRootShopId,
        rootCategoryPath: rootCategoryPath,
        pageType: shopId.current ? Constants.LANDMARK_PAGETYPE_AOP : Constants.LANDMARK_PAGETYPE_SRP,
    };

    return <articleOverviewStaticContext.Provider value={value}>{children} </articleOverviewStaticContext.Provider>;
}

export default {articleOverviewStaticContext};
